export const isAffiliateOnlyBrand = (id: string) => id.includes('affiliate-');
